<template>
  <div class="fr-wrapper">

    <img src="../../assets/img/logo.svg?v=5.5.1" id="logo" v-if="!isInIframe">

    <div class="container fr-page">
      <div :id="id" :class="$props.class">

        <div class="m-md-5 login-frame">

          <div class="login-header">
            <h1 class="title">{{ $props.title }}</h1>
            <div id="little-rect"></div>
          </div>

          <slot></slot>

        </div>

        <fr-footer v-if="!isInIframe"></fr-footer>

      </div>
    </div>

  </div>
</template>

<script lang="ts">
import FrFooter from './FrFooter.vue';

export default {
  name: 'ForgerockTemplate',
  components: { FrFooter },
  props: {
    id: String,
    title: String,
    class: { type: String, default: 'page' },
  },
  computed: {
    isInIframe: () => (window.self !== window.top),
  }
};
</script>
